// Roadside Options - Personal
export const RSA_ARV002 = 'ARV002'; // RACQ RV
export const RSA_AR006 = 'AR006'; //RACQ Everyday Lite
export const RSA_AR007 = 'AR007'; //RACQ Everyday
export const RSA_AR008 = 'AR008'; //RACQ Everyday Plus
export const RSA_AR009 = 'AR009'; //RACQ Ultra Care
export const RSA_AR010 = 'AR010'; //RACQ Ultimate Care
export const RSA_RACQ_RV = 'RACQ RV';
export const RSA_RACQ_EVERYDAY_LITE = 'RACQ Everyday Lite';
export const RSA_RACQ_EVERYDAY = 'RACQ Everyday';
export const RSA_RACQ_EVERYDAY_PLUS = 'RACQ Everyday Plus';
export const RSA_RACQ_ULTRA_CARE = 'RACQ Ultra Care';
export const RSA_RACQ_ULTIMATE_CARE = 'RACQ Ultimate Care';
export const RSA_ROADSIDE_EXCESS_USE = 'AREX1';

export const LIFESTYLE_FORDNCO = 'ALF001'; //Ford NCO

// Roadside Options - Business
export const RSA_ARB001 = 'ARB001'; //Roadside for Business
export const RSA_ARB002 = 'ARB002'; //Plus Care for Business
export const RSA_RACQ_ROADSIDE_FOR_BUSINESS = 'RACQ Roadside for Business';
export const RSA_RACQ_PLUS_CARE_FOR_BUSINESS = 'RACQ Plus Care for Business';

// Associate RSA product codes
export const RSA_ARN001 = 'ARN001'; //Associate Motoring
export const RSA_ARN002 = 'ARN002'; //Associate Plus Care
export const RSA_ARN003 = 'ARN003'; //Associate Ultra Care
export const RSA_ARN004 = 'ARN004'; //Associate RACQ Ultimate
export const RSA_ARN005 = 'ARN005'; //Associate RACQ Everyday Plus
export const RSA_ARN006 = 'ARN006'; //Associate RACQ Ultra Care
export const RSA_ARN007 = 'ARN007'; //Associate RACQ Ultimate Care

export enum RoadsideProductType {
  Standard = 'Standard',
  Business = 'Business',
  Free2Go = 'Free2Go',
  Cmo = 'Cmo',
  Absentee = 'Absentee',
}

const RoadsideProductNameToProductCodeMap: { [key: string]: string } = {
  // Map contains both space and non-space key names, ensure both values are kept in sync

  // Personal
  RACQRV: RSA_ARV002,
  'RACQ RV': RSA_ARV002,

  RACQEverydayLite: RSA_AR006,
  'RACQ Everyday Lite': RSA_AR006,

  RACQEveryday: RSA_AR007,
  'RACQ Everyday': RSA_AR007,

  RACQEverydayPlus: RSA_AR008,
  'RACQ Everyday Plus': RSA_AR008,

  RACQUltraCare: RSA_AR009,
  'RACQ Ultra Care': RSA_AR009,

  RACQUltimateCare: RSA_AR010,
  'RACQ Ultimate Care': RSA_AR010,

  // Business
  RACQRoadsideBusiness: RSA_ARB001,
  'RACQ Roadside for Business': RSA_ARB001,

  RACQPlusCareBusiness: RSA_ARB002,
  'RACQ Plus Care for Business': RSA_ARB002,
};
export function getRoadsideProductCodeFromProductName(roadsideProductName: string): string | undefined {
  return RoadsideProductNameToProductCodeMap[roadsideProductName];
}

const RoadsideProductCodeToProductNameMap: { [key: string]: string } = {
  // Personal
  ARV002: RSA_RACQ_RV,
  AR006: RSA_RACQ_EVERYDAY_LITE,
  AR007: RSA_RACQ_EVERYDAY,
  AR008: RSA_RACQ_EVERYDAY_PLUS,
  AR009: RSA_RACQ_ULTRA_CARE,
  AR010: RSA_RACQ_ULTIMATE_CARE,

  // Business
  ARB001: RSA_RACQ_ROADSIDE_FOR_BUSINESS,
  ARB002: RSA_RACQ_PLUS_CARE_FOR_BUSINESS,
};
export function getRoadsideProductNameFromProductCode(roadsideProductCode: string): string | undefined {
  return RoadsideProductCodeToProductNameMap[roadsideProductCode];
}
